import React from 'react';
import { getReviewerPath } from 'sly/resourceCenter/helpers';
import { Link } from 'sly/system';

function ReviewedByBlock({ reviewer }) {
  if (!reviewer) {
    return null;
  }
  const reviewerPagePath = reviewer ? getReviewerPath(reviewer.slug) : null;
  return (
    <>
      <div className='flex items-center gap-1'>
        <div className='font-l-m uppercase tracking-[1px] text-slate-lighter-40'>
          Reviewed by:
        </div>
        <Link to={reviewerPagePath} className='font-t-m text-slate-base'>
          {reviewer.fullName || reviewer.firstName}
        </Link>
      </div>
    </>
  );
}

export default ReviewedByBlock;
